import React from 'react';
import MockCourierMapMarker from '../../../DeliveryDashboardMapMarkers/components/MapMarkers/MockCourierMapMarker';
import MockOrderMapMarker from '../../../DeliveryDashboardMapMarkers/components/MapMarkers/MockOrderMapMarker';
import {
  CourierReturnStatusType,
  CourierVehicleType,
  DeliveryStatus,
  OrderStatus,
} from '@src/pages/DeliveryDashboard/models/model-enum';

import style from './OnboardingStepMarkers.module.scss';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import dayjs from 'dayjs';

interface componentProps {
  stepNumber: number;
}

const OnboardingStepMarkers = ({ stepNumber = 1 }: componentProps) => {
  const { isResolutionMobile } = useDeviceDetect();
  const step1Markers = (
    <>
      <MockCourierMapMarker
        insertElement={
          <div id="tutorial-marker-higlighter-1" className={style.step1_marker_higlighter}></div>
        }
        vehicleType={CourierVehicleType.Bike}
        courierName={'Dave'}
        location={{
          latitude: 52.495199402,
          longitude: !isResolutionMobile ? 13.43268402709741 : 13.43342062709741,
        }}
        returnStatusType={DeliveryStatus.InDelivery as any}
      />
      <MockCourierMapMarker
        vehicleType={CourierVehicleType.Bike}
        courierName={'Waseem'}
        location={{
          latitude: 52.495199402,
          longitude: !isResolutionMobile ? 13.436900158513591 : 13.43719360851359,
        }}
        returnStatusType={CourierReturnStatusType.Returning}
      />
    </>
  );

  const step2Markers = (
    <>
      <MockOrderMapMarker
        insertElement={
          <div id="tutorial-marker-higlighter-2" className={style.step2_marker_highlighter}></div>
        }
        orderStatus={OrderStatus.Unassigned}
        position={{ lat: 52.495199402, lng: 13.43283072709741 }}
        showCard={true}
        customerInformation={'John Doe'}
        dueTime={dayjs().add(25, 'minute').format('HH:mm')}
      />
      <MockOrderMapMarker
        orderStatus={OrderStatus.InDelivery}
        position={{
          lat: 52.494481572,
          lng: 13.435866958513591,
        }}
        showCard={true}
        customerInformation={'John Doe'}
        dueTime={dayjs().add(25, 'minute').format('HH:mm')}
      />
      <MockOrderMapMarker
        customerInformation={'John Doe'}
        dueTime={dayjs().add(25, 'minute').format('HH:mm')}
        orderStatus={OrderStatus.Delivered}
        position={{
          lat: 52.495199402,
          lng: 13.438005,
        }}
        showCard={true}
      />
    </>
  );

  const markers = [step1Markers, step2Markers];

  return markers[stepNumber - 1] || markers[1];
};

export default OnboardingStepMarkers;
